import { createActionConst } from '../../../utils/action.utils';

const CONCLUSION_NAMESPACE = 'CONCLUSION';

export const STORE_CONCLUSION = createActionConst(CONCLUSION_NAMESPACE, 'STORE_CONCLUSION');
export const CLEAR_CONCLUSION = createActionConst(CONCLUSION_NAMESPACE, 'CLEAR_CONCLUSION');
